import React from 'react';
import PropTypes from 'prop-types';
import {Redirect} from "react-router-dom";
import routerConfig from '../../config/router';
import MainInfo from './components/MainInfo'
import ChangeEmailModal from './components/ChangeEmailModal';
import ChangePasswordModal from './components/ChangePasswordModal';
import DeleteUserAccount from './components/DeleteUserAccount';
import './Profile.scss';

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  static propTypes = {
    successUpdated: PropTypes.bool,
    userData: PropTypes.object,
    error: PropTypes.object,
    handleChange: PropTypes.func,
    editProfile: PropTypes.func,
    isOpenModalChangeEmail: PropTypes.bool,
    toggleShowChangeEmailModal: PropTypes.func,
    changeUserEmail: PropTypes.func,
    isOpenModalChangePassword: PropTypes.bool,
    toggleShowChangePasswordModal: PropTypes.func,
    changeUserPassword: PropTypes.func,
    isOpenModalDeleteAccount: PropTypes.bool,
    toggleShowDeleteAccountModal: PropTypes.func,
    deleteAccount: PropTypes.func,
  };

  render() {
    const {
      successUpdated,
      userData,
      error,
      handleChange,
      editProfile,
      isOpenModalChangeEmail,
      toggleShowChangeEmailModal,
      changeUserEmail,

      isOpenModalChangePassword,
      toggleShowChangePasswordModal,
      changeUserPassword,

      isOpenModalDeleteAccount,
      toggleShowDeleteAccountModal,
      deleteAccount
    } = this.props;

    if (Object.keys(userData).length !== 0)
      return (
        <div>
          {
            isOpenModalChangeEmail ?
              <ChangeEmailModal
                isOpenModalChangeEmail={isOpenModalChangeEmail}
                toggleShowChangeEmailModal={toggleShowChangeEmailModal}
                currentEmail={userData.email}
                error={error}
                changeUserEmail={changeUserEmail}
              /> : null
          }
          {
            isOpenModalChangePassword ?
              <ChangePasswordModal
                isOpenModalChangePassword={isOpenModalChangePassword}
                toggleShowChangePasswordModal={toggleShowChangePasswordModal}
                error={error}
                changeUserPassword={changeUserPassword}
              /> : null
          }
          {
            isOpenModalDeleteAccount ?
              <DeleteUserAccount
                isOpenModalDeleteAccount={isOpenModalDeleteAccount}
                toggleShowDeleteAccountModal={toggleShowDeleteAccountModal}
                error={error}
                deleteAccount={deleteAccount}
              /> : null
          }
          <MainInfo
            {...userData}
            error={error}
            successUpdated={successUpdated}
            editProfile={editProfile}
            handleChange={handleChange}
            showChangeEmail={toggleShowChangeEmailModal}
            showChangePassword={toggleShowChangePasswordModal}
            showDeleteAccount={toggleShowDeleteAccountModal}
          />
        </div>
      );
    return (
      <Redirect
        to={routerConfig.home}
      />
    )
  }
}

export default Profile;




// WEBPACK FOOTER //
// ./src/app/containers/Profile/Component.js